import { TEventJournalQuery } from '@entities/eventJournal/model/types';

// будет возвращать только те значения, которые не пустые
export const filterParamsToQueryKeys = (
    filterParams: Partial<Record<TEventJournalQuery, string>> = {}
) =>
    Object.entries(filterParams).reduce((acc, [key, value], i, arr) => {
        const divider = arr.length - 1 === i ? '' : '&';
        if (!value) return acc;
        acc += `${key}=${value}${divider}`;
        return acc;
    }, '');

// будет возвращать все значения, даже если они пустые
export const filterParamsToQueryKeysWithAllValues = (
    filterParams: Partial<Record<TEventJournalQuery, string>> = {}
) =>
    Object.entries(filterParams).reduce((acc, [key, value], i, arr) => {
        const divider = arr.length - 1 === i ? '' : '&';
        acc += `${key}=${value}${divider}`;
        return acc;
    }, '');
